import saga from 'Modules/2fa/store/saga'
import reducer from 'Modules/2fa/store/reducer'
import { useInjectReducer, useInjectSaga } from 'Stores'
import { useDispatch, useSelector } from 'react-redux'
import { makeSelect2fa } from 'Modules/2fa/store/selectors'
import { generateCode, reset2fa, verifyCode, verifyCodeReset } from 'Modules/2fa/store/actions'

export const use2FA = () => {
  useInjectSaga({ key: 'setting2fa', saga })
  useInjectReducer({ key: 'setting2fa', reducer })

  const { qrCode, verify } = useSelector(
    makeSelect2fa()
  )

  const dispatch = useDispatch()
  const reset2faAction = () => dispatch(reset2fa())
  const verifyCodeAction = (payload) => dispatch(verifyCode(payload))
  const verifyCodeResetAction = (payload) => dispatch(verifyCodeReset(payload))
  const generateCodeAction = () => dispatch(generateCode())

  return {
    verify,
    qrCode,
    reset2faAction,
    verifyCodeAction,
    generateCodeAction,
    verifyCodeResetAction
  }
}
